import{z as e}from"zod";const t=e.object({title:e.string().min(1).max(255),content:e.string().min(1).max(5e4)}).strict();export{t as createTermsDto};
//# sourceMappingURL=create-terms.dto.mjs.map